import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.UsersPage.UserList.DelegateTimeZoneCell', {
    placeholder: 'Select...',
    tooltip: 'Choose the time zone in which you want to see the dates of delegation.',
});
